module.exports = __webpack_public_path__ + "img/know-more.4e8b494.png";